const rules = {
	user: {
		static: [],
	},

	superv: {
		static: [
			"drawer-superv-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
		],
	},

	admin: {
		static: [
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:transferWhatsapp",
			"contacts-page:deleteContact",
		],
	},
};

export default rules;
